/**
 *
 * Returns the list of missing keys giving an object and its required keys.
 * A parameter is missing if its value is undefined or ''.
 * A value of 0 or null is not considered as missing.
 *
 * @param {object} obj object to check.
 * @param {array} required list of required keys.
 *        Each element can be multi level deep using a '.' separator e.g. 'myRequiredObj.myRequiredKey'
 *
 * @returns {array}
 * @private
 */
export function getMissingKeys(obj, required) {
  return required.filter((r) => {
    const splits = r.split('.');
    const last = splits[splits.length - 1];
    const traverse = splits.slice(0, -1).reduce((tObj, split) => {
      tObj = tObj[split] || {};
      return tObj;
    }, obj);
    return traverse[last] === undefined || traverse[last] === ''; // missing default params are empty string
  });
}

export function getBadParams(obj, rules) {
  const badParams = [];
  const keys = Object.keys(obj);
  keys.forEach((key) => {
    const rule = rules[key];
    if (rule) {
      const valueType = Object.prototype.toString.call(obj[key]).split(' ')[1].slice(0, -1).toLowerCase();
      if (!rule.allowedTypes.includes(valueType)) {
        badParams.push({ name: key, error: `${key} should be of type: ${rule.allowedTypes.join(', ')}` });
      }
    }
  });
  return badParams;
}

// https://stackoverflow.com/questions/29085197/how-do-you-json-stringify-an-es6-map
export function mapToJSONReplacer(key, value) {
  if (value instanceof Map) {
    return {
      dataType: 'Map',
      value: [...value],
    };
  } else {
    return value;
  }
}

export function JSONToMapReviver(key, value) {
  if (typeof value === 'object' && value !== null) {
    if (value.dataType === 'Map') {
      return new Map(value.value);
    }
  }
  return value;
}

/**
 * Use this to shuffle the elements of an array. The elements will be shuffled in place and the function also returns your array to allow for further chaining.
 * @param {any[]} array Your array.
 * @returns {any[]} Your shuffled array.
 */
export const shuffleArray = function (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};
